import {bookingService} from "../network/services/booking.service";
import {ResponseError} from "../network/response/response-error";

export default {
  namespaced: true,
  state: {
    totalPrice: null,
    modalOpenState: false,
    form: {
      priceDisplayed: false,
      hasInformation: false,
      hasCard: false,
      termAccepted: false
    },
    data: {
      rooms: [],
      infos: null,
      promoCode: null,
      card: null,
      address_id: null
    }
  },
  mutations: {
    SET_DATA_ADDRESS(state, payload) {
      state.data.address_id = payload;
    },
    SET_DATA_CARD(state, payload) {
      state.data.card = payload;
    },
    SET_DATA_PROMO(state, payload) {
      state.data.promoCode = payload;
    },
    SET_DATA_ROOMS(state, payload) {
      state.data.rooms = payload;
    },
    SET_DATA_INFOS(state, payload) {
      state.data.infos = payload;
    },
    SET_TERM_ACCEPTED(state, payload) {
      state.form.termAccepted = !!payload;
    },
    SET_PRICE_DISPLAYED(state, payload) {
      state.form.priceDisplayed = !!payload;
    },
    SET_HAS_INFORMATION(state, payload) {
      state.form.hasInformation = !!payload;
    },
    SET_HAS_CARD(state, payload) {
      state.form.hasCard = !!payload;
    },
    SET_TOTAL_PRICE(state, payload) {
      state.totalPrice = payload;
    },
    SET_MODAL_OPEN_STATE(state, payload) {
      state.modalOpenState = !!payload
    }
  },
  actions: {
    reset({commit}) {
      commit('SET_TERM_ACCEPTED', false);
      commit('SET_PRICE_DISPLAYED', false);
      commit('SET_HAS_INFORMATION', false);
      commit('SET_HAS_CARD', false);
      commit('SET_DATA_CARD', null);
      commit('SET_DATA_PROMO', null);
      commit('SET_DATA_ROOMS', []);
      commit('SET_DATA_INFOS', null);
      commit('SET_DATA_ADDRESS', null);
      commit('SET_MODAL_OPEN_STATE', false);
    },
    async createBooking(context, data) {
      const accessToken = context.rootState.client.tokens.accessToken;
      if (!accessToken) return;
      const realData = {
        rooms: data.rooms.map(room => ({
          id: room.room.id,
          start: room.start,
          end: room.end,
          priceplan: room.room_price_id,
          nb_guest: room.price_plans[0].input_prices[0].nbGuest,
          extras: room.extras.map(extra => ({
            id: extra.extra.id,
            dates: extra.dates
          })),
        })),
        infoPhone: data.infos.phone,
        infoEmail: data.infos.email,
        infoFirstName: data.infos.firstName,
        infoLastName: data.infos.lastName,
        promoCode: data.promoCode,
        card: data.card.cardData.id,
        address_id: data.address_id
      };
      const response = await bookingService.createBooking(accessToken, realData);
      if (response instanceof ResponseError) {
        // error
        console.error(response);
        return;
      }

      const paymentIntent = response.get('Booking.create.paymentIntent', null);

      if (paymentIntent.hasOwnProperty('error')) {
          return {
            redirect: null,
            params: {
              payment_intent_client_secret: paymentIntent.error.payment_intent.client_secret,
              payment_intent: paymentIntent.error.payment_intent.id
            }
          }
      }
      if (paymentIntent.hasOwnProperty('link')) {
        return {
          redirect: String(result.link),
        }
      } else if (typeof paymentIntent === 'string') {
        return {
          redirect: String(result),
        }
      } else if (paymentIntent.next_action && paymentIntent.next_action.type === 'redirect_to_url') {
        return {
          redirect: String(paymentIntent.next_action.redirect_to_url.url)
        }
      } else if (paymentIntent.next_action && paymentIntent.next_action.type === 'three_d_secure_redirect') {
        return {redirect: String(paymentIntent.next_action.stripe_js.url)}
      }
      return {
        redirect: null,
        params: {
          payment_intent_client_secret: paymentIntent.client_secret,
          payment_intent: paymentIntent.id
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/booking-step4.store.js